/**
 * Generic modal
 * @method setAlertModal
 */
export function ModalController() {
    //generic
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    this.noInternetModal = null;
    this.errorModal = null;
    //authen
    this.pdpaModal = null;
    //redeem
    this.confirmRedeemModal = null;
    this.serialModal = null;
    this.drawDeliveryModal = null;
    this.shippingAddressModal = null;
    this.copySerialSuccessModal = null;
    this.verifyCodeModal = null;
    //address
    this.addAddressModal = null;
    this.editAddressModal = null;
    this.listAddressModal = null;
    this.addTaxAddressModal = null;
    this.editTaxAddressModal = null;
    this.listTaxAddressModal = null;
    //other core modal
    this.otpModal = null;
    this.registerSuccessModal = null;
    this.marketingOptionModal = null;
    //history
    this.deliveryStatusModal = null;
    this.copySuccessModal = null;
    this.freeStarbuckModal = null;
    //mission
    this.alertMissionModal = null;
    this.missionConfirmModal = null;

    //#region generic
    this.setAlertModal = function(alertModalController) {
        this.alertModal = alertModalController;
    };
    this.setConfirmModal = function (confirmModalController) {
        this.confirmModal = confirmModalController;
    };
    this.setLoadingModal = function (loadingModalController) {
        this.loadingModal = loadingModalController;
    };
    this.setNoInternetModal = function (noInternetModalController) {
        this.noInternetModal = noInternetModalController;
    };
    this.setErrorModal = function (ErrorModalController) {
        this.errorModal = ErrorModalController;
    };
    //#endregion generic

    //#region authen
    this.setPdpaModal = function (pdpaModalController) {
        this.pdpaModal = pdpaModalController;
    };
    //#endregion authen

    //#region redeem
    this.setConfirmRedeemModal = function (confirmRedeemModalController) {
        this.confirmRedeemModal = confirmRedeemModalController;
    };
    this.setSerialModal = function (serialModalController) {
        this.serialModal = serialModalController;
    };
    this.setDrawDeliveryModal = function (drawDeliveryModalController) {
        this.drawDeliveryModal = drawDeliveryModalController;
    };
    this.setShippingAddressModal = function (shippingAddressModalController) {
        this.shippingAddressModal = shippingAddressModalController;
    };
    this.setCopySerialSuccessModal = function (copySerialSuccessModalController) {
        this.copySerialSuccessModal = copySerialSuccessModalController;
    };
    this.setVerifyCodeModal = function (verifyCodeModalController) {
        this.verifyCodeModal = verifyCodeModalController;
    };
    //#endregion redeem

    //#region address
    this.setAddAddressModal = function (addAddressModalController) {
        this.addAddressModal = addAddressModalController;
    };
    this.setEditAddressModal = function (editAddressModalController) {
        this.editAddressModal = editAddressModalController;
    };
    this.setListAddressModal = function (listAddressModalController) {
        this.listAddressModal = listAddressModalController;
    };
    this.setAddTaxAddressModal = function (addTaxAddressModalController) {
        this.addTaxAddressModal = addTaxAddressModalController;
    };
    this.setEditTaxAddressModal = function (editTaxAddressModalController) {
        this.editTaxAddressModal = editTaxAddressModalController;
    };
    this.setListTaxAddressModal = function (listTaxAddressModalController) {
        this.listTaxAddressModal = listTaxAddressModalController;
    };
    //#endregion address

    //#region other core modal
    this.setOtpModal = function (otpModalController) {
        this.otpModal = otpModalController;
    };
    this.setRegisterSuccessModal = function (registerSuccessModalController) {
        this.registerSuccessModal = registerSuccessModalController;
    };
    this.setMarketingOptionModal = function (marketingOptionModalController) {
        this.marketingOptionModal = marketingOptionModalController;
    };
    //#endregion other core modal

    // #region history modal
    this.setDeliveryStatusModal = function(deliveryStatusModalController) {
        this.deliveryStatusModal = deliveryStatusModalController;
    };
    this.setCopySuccessModal = function (copySuccessModalController) {
        this.copySuccessModal = copySuccessModalController;
    };
    this.setFreeStarbuckModal = function (freeStarbuckModalController) {
        this.freeStarbuckModal = freeStarbuckModalController;
    };
    // #end region history modal

    // #region mission modal
    this.setMissionAlertModal = function(missionAlertModalController) {
        this.missionAlertModal = missionAlertModalController;
    };
    this.setMissionConfirmModal = function(missionConfirmModalController) {
        this.missionConfirmModal = missionConfirmModalController;
    };
    // #endregion mission modal
}
